import { message } from 'antd'

import { KVMessageDef } from './index'

export function getBatchScreenshotCompleteMessage() {
  return {
    type: 'batchScreenshotComplete',
    requiredData: ['requestId', 'success', 'completed', 'failed', 'total'],

    callback: (json: Record<string, unknown>) => {
      const requestId = json.requestId as string
      const success = json.success as boolean
      const completed = json.completed as number
      const failed = json.failed as number
      const total = json.total as number

      if (success) {
        message.success(
          `Batch screenshot complete: ${completed}/${total} succeeded, ${failed} failed`
        )
      } else {
        message.error(`Batch screenshot failed or cancelled`)
      }

      // eslint-disable-next-line no-console
      console.log(
        `[BatchScreenshot] Complete - Success: ${success}, Completed: ${completed}, Failed: ${failed}, Total: ${total}`
      )

      // Dispatch custom event for UI components to listen to
      window.dispatchEvent(
        new CustomEvent('batchScreenshotComplete', {
          detail: {
            requestId,
            success,
            completed,
            failed,
            total,
          },
        })
      )
    },
  } as KVMessageDef
}
